import styled from 'styled-components';

export const Container = styled.main`
	display: flex;
	flex-direction: column;
	gap: 1.2rem;
	height: calc(100vh - 14rem);
	padding: 1.6rem 0 0 0;
	${({ theme }) => theme.common.container};
`;

export const SectionsRow = styled.div`
	display: flex;
	flex: 1;
	gap: 3rem;
	width: 100%;
`;

export const TreeSection = styled.section`
	display: flex;
	flex: 0 0 16rem;
	width: 16rem;
	min-width: 16rem;
	max-width: 16rem;
`;

export const RightSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	flex: 1;
	min-width: 0;
	height: 80%;
	max-height: 80%;
`;

export const PromptEditorsSection = styled.section`
	display: grid;
	grid-template-columns: minmax(0, 4.5fr) minmax(0, 0.4fr) minmax(0, 4.5fr);
	column-gap: 3%;
	flex: 1 1 auto;
	min-width: 0;
`;

export const TreeWrap = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
	width: 100%;
`;

export const SourcePromptSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	flex: 1;
	min-width: 0;
`;

export const TreeHeader = styled.button`
	display: flex;
	align-items: center;
	gap: 0.6rem;
	height: 3rem;
	padding: 0 1rem;
	border: 1px solid ${({ theme }) => theme.color.light_gray || '#d0d5dd'};
	border-radius: 999px;
	background: ${({ theme }) => theme.color.gray_ef || '#f3f4f6'};
	color: ${({ theme }) => theme.color.gray_70};
	font-family: NotoSansKR-Bold;
	font-size: 1.3rem;
	cursor: pointer;
	transition: all 0.15s ease;
	text-align: left;

	&:hover {
		background: ${({ theme }) => theme.color.gray};
		border-color: ${({ theme }) => theme.color.gray_90 || '#9ca3af'};
	}

	&:focus-visible {
		outline: 2px solid ${({ theme }) => theme.color.orange};
		outline-offset: 2px;
	}
`;

export const TreeChildren = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
	padding-left: 1.8rem;
`;

export const CopySection = styled.section`
	display: flex;
	align-items: center;
	justify-content: center;
	min-width: 0;
`;

export const LastSection = styled.section`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	min-width: 0;
`;

export const BottomActionRow = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
	justify-content: flex-end;
	align-items: flex-end;
`;

export const BottomActionItem = styled.div`
	display: flex;
	align-items: center;
	gap: 0.8rem;
`;

export const BottomActionLabel = styled.p`
	margin: 0;
	color: ${({ theme }) => theme.color.gray_70};
	font-size: 1.3rem;
	line-height: 1.3;
	text-align: right;
`;

export const SideButton = styled.button`
	height: 3.6rem;
	min-height: 3.6rem;
	min-width: 9rem;
	margin: 0;
	border: none;
	border-radius: 0.8rem;
	background: ${({ theme }) => theme.color.orange};
	color: #fff;
	font-family: NotoSansKR-Bold;
	font-size: 1.5rem;
	cursor: pointer;

	&.treeChild {
		display: flex;
		align-items: center;
		width: 100%;
		height: 3rem;
		min-height: 3rem;
		padding: 0 1rem;
		margin: 0;
		border: 1px solid ${({ theme }) => theme.color.light_gray || '#d0d5dd'};
		border-radius: 999px;
		background: ${({ theme }) => theme.color.gray_ef || '#f3f4f6'};
		color: ${({ theme }) => theme.color.gray_70};
		font-size: 1.3rem;
		text-align: left;
		justify-content: flex-start;
		transition: all 0.15s ease;

		&:hover {
			background: ${({ theme }) => theme.color.gray};
			border-color: ${({ theme }) => theme.color.gray_90 || '#9ca3af'};
		}

		&:focus-visible {
			outline: 2px solid ${({ theme }) => theme.color.orange};
			outline-offset: 2px;
		}

		&:active {
			transform: translateY(1px);
		}
	}
`;

export const CopyButton = styled.button`
	width: 4.4rem;
	height: 4.4rem;
	border: none;
	border-radius: 50%;
	background: ${({ theme }) => theme.color.orange};
	color: #fff;
	font-size: 1.8rem;
	cursor: pointer;
`;

export const Label = styled.p`
	margin: 0;
	font-family: NotoSansKR-Bold;
	font-size: 1.5rem;
	color: ${({ theme }) => theme.color.gray_70};
`;

export const EditBox = styled.textarea`
	width: 100%;
	flex: 1;
	resize: none;
	padding: 1.2rem;
	border-radius: 0.8rem;
	border: 1px solid ${({ theme }) => theme.color.light_gray || '#d0d5dd'};
	background: ${({ readOnly }) => (readOnly ? '#f5f7fa' : '#fff')};
	color: ${({ theme }) => theme.color.gray_70};
	font-family: NotoSansKR-Regular;
	font-size: 1.4rem;
	line-height: 1.6;

	&:focus {
		outline: 1px solid ${({ theme }) => theme.color.orange};
	}
`;
